import React from "react";
import ComeBackTimer from "../../ComeBackTimer";

const Screen04 = () => {
    return <ComeBackTimer />;
};

export default Screen04;
